import { LinearProgress } from '@mui/material';
import DataTable from 'react-data-table-component';

function MyComponent({ rows, columns, title }) {
    const filteredColumns = columns?.map((title, idx) => ({ name: title?.toUpperCase(), selector: (row) => row?.[title], sortable: true }))
    return (
        <DataTable
            columns={[
                {
                    name: 'S.No',
                    selector: (_, idx) => idx + 1,
                    width: '80px', // or '5%' for a percentage width
                    // sortable: true // You might still want to keep it sortable
                },
                ...filteredColumns
            ]}
            data={rows}
            fixedHeader
            pagination
            paginationPerPage={50}
            paginationRowsPerPageOptions={[50, 75, 100]}
            title={title}
            // dense
            // progressPending={true}
            striped={true}
            highlightOnHover
            progressComponent={<LinearProgress />}
        />
    );
};
export default MyComponent;